/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { Route, Switch, Link, useHistory } from "react-router-dom";
import axios from "axios/index";
// javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from "perfect-scrollbar";

// core components
// import AdminNavbar from "../../components/Navbars/AdminNavbar.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";
import LeftSidebar from '../../components/Sidebar/LeftSidebar';
// import FixedPlugin from "../../components/FixedPlugin/FixedPlugin.jsx";
import { routes } from "../../routes.js";
import Blade from "../../components/Blade/Blade";
import { appState } from "../../AppState";
import NotFound from "../../components/NotFound";

import {
  Button,
  Container,
  UncontrolledTooltip
} from "reactstrap";
import { TicketTabIndicator } from "../../components/Dashboard/TabbedDashboard.jsx";
import AppAlert from "../../components/AppAlert/AppAlert.jsx";
import Clickstream from "../../components/Clickstream/Clickstream.jsx";
import Enum from "../../utility/enum.js";
import useAsyncEffect from "../../utility/use-async-effect";
import SpoofBanner from "../../utility/SpoofBanner.js";
import ConnectriaAnnoucement from "../../utility/ConnectriaAnnoucment.js";
import { SessionTimeoutModal } from "../../components/misc.jsx";
import { ContentPanel } from "../../components/Devices/DeviceDetailPage.jsx";
import CookieService from "../../services/CookieService";
import OrganizationService from "../../services/OrganizationService";
var ps;



export const App = (props) => {
  //local state
  const [sidebarOpened, setSidebarOpened] = useState(document.documentElement.className.indexOf("nav-open") !== -1);
  const [leftSidebarOpened, setLeftSidebarOpened] = useState(!!document.querySelector('.left-sidebar.expanded'));
  const [backgroundColor, setBackgroundColor] = useState("primary");
  const [burgerCssClass, setBurgerCssClass] = useState("burger-container");

  const [customerMessage, setCustomerMessage] = useState(null);
  const source = axios.CancelToken.source();

  //global state
  const [stateApp, stateAppActions] = appState();
  const history = useHistory();

  //un-comment below if we have issues with IE's scrollbar
  //componentDidMount -- notice second arg empty array 
  // useEffect(() => {
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     document.documentElement.className += " perfect-scrollbar-on";
  //     document.documentElement.classList.remove("perfect-scrollbar-off");
  //     ps = new PerfectScrollbar(this.refs.mainPanel, { suppressScrollX: true });
  //     let tables = document.querySelectorAll(".table-responsive");
  //     for (let i = 0; i < tables.length; i++) {
  //       ps = new PerfectScrollbar(tables[i]);
  //     }
  //   }
  // }, []);

  // //componentDidUpdate
  // useEffect(() => {
  //   if (e.history.action === "PUSH") {
  //     if (navigator.platform.indexOf("Win") > -1) {
  //       let tables = document.querySelectorAll(".table-responsive");
  //       for (let i = 0; i < tables.length; i++) {
  //         ps = new PerfectScrollbar(tables[i]);
  //       }
  //     }
  //     document.documentElement.scrollTop = 0;
  //     document.scrollingElement.scrollTop = 0;
  //     this.refs.mainPanel.scrollTop = 0;
  //   }
  //   //old componentWillUnmount support.. might need a different approach if we see perf issues
  //   return () => {
  //     if (navigator.platform.indexOf("Win") > -1) {
  //       ps.destroy();
  //       document.documentElement.className += " perfect-scrollbar-off";
  //       document.documentElement.classList.remove("perfect-scrollbar-on");
  //     }
  //   }
  // });

  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    if (!sidebarOpened) {
      setBurgerCssClass("burger-container burger-change");
    } else {
      setBurgerCssClass("burger-container");
    }
    setSidebarOpened(!sidebarOpened);
  };

  const toggleLeftSidebar = (open) => setLeftSidebarOpened(typeof open === 'boolean' ? open : o => !o);
  
  const handleBgClick = (color) => {
    setBackgroundColor(color);
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  //get the raw routes (excluding groups)
  //only support one level of hierarchy
  const rawRoutes = () => {
    let result = [];
    for (var i = 0; i < routes.length; i++) {
      if (routes[i].group) {
        for (var ii = 0; ii < routes[i].routes.length; ii++) {
          result.push(routes[i].routes[ii]);
        }
      } else {
        result.push(routes[i]);
      }
    }
    return result;
  }

  useEffect(() => {
    history.listen((location) => {
      stateAppActions.setPageNavTitle("");
      stateAppActions.setPageBackTitle("");

      // Refresh session timeout time when user goes to a new page
      if (history.location.pathname != "/login") {
        var d = new Date();
        d.setMinutes(d.getMinutes() + 720);
        CookieService.setCookie("session_timeout_time", d.getTime(), 1, stateApp.env);
        stateAppActions.setSessionTimeoutTime(d.getTime());
      }
    });
  }, []);

  useAsyncEffect(
    async isMounted => {
        try {

            let message = await OrganizationService.customer_message();
            
            if (!isMounted()) return;
            if (message.data && message.data.template) {
              let replaceIndex = 0;
              const formattedMessage = message.data.template.replace(/<([^>]+)>/g, (match, label) => {
                  if (!message.data.links || replaceIndex >= message.data.links.length) {
                      return match;
                  }
                  const _link = `<a href="${message.data.links[replaceIndex]}" target="_blank">${label}</a>`;
                  replaceIndex += 1;
                  return _link;
              });
              setCustomerMessage(formattedMessage);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // request cancelled
            } else {
                throw error;
            }
        }
    },
    () => {
        source.cancel();
    },
    []
  );
  
  return (
    <>
    <SpoofBanner></SpoofBanner>
    <ConnectriaAnnoucement></ConnectriaAnnoucement>
      <AppAlert 
        visible={stateApp.alert.visible} 
        className={stateApp.alert.className}
        color={stateApp.alert.color}>
          {stateApp.alert.content}
      </AppAlert>
      <div className="wrapper">
        {stateApp.env === Enum.Env.DEV &&
          <LeftSidebar
            isOpen={leftSidebarOpened}
            routes={routes}
            toggleSidebar={toggleLeftSidebar}
          />
        }
        <Sidebar
          {...props}
          routes={routes}
          bgColor={backgroundColor}
          toggleSidebar={toggleSidebar}
        />
        <div
          className="main-panel"
          // ref="mainPanel"
          data={backgroundColor}
        >
          {customerMessage &&
            <div className="alert alert-danger mb-0 rounded-0" role="alert" dangerouslySetInnerHTML={{ __html: customerMessage }} />
          }
          <div className="shadow-sm rounded" style={{backgroundColor: "#FFFFFF"}}>
            <div className="container-fluid">
              <div className="row py-2" style={{marginBottom:"10px", marginLeft:"unset", marginRight: "unset"}}>
                <div className="col-4 col-xl-auto">
                  <div className="d-flex ml-2 h-100 align-items-center">
                    <div className={`${burgerCssClass} d-block d-xl-none mr-2`} onClick={() => toggleLeftSidebar()}>
                      <div className="burger-bar1"></div>
                      <div className="burger-bar2"></div>
                      <div className="burger-bar3"></div>
                    </div>
                    <h4 className="m-0 app-back-title">{stateApp.pageBackTitle}</h4>
                  </div>
                </div>
                <div className="col text-center text-xl-left">
                  <Link to="/app/dashboard" className="d-none d-md-inline">
                    <img className="logo-image my-2" src="data:image/png;base64,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"></img>
                    {/* <img width="158px" className="mt-2 mb-2 d-none d-lg-inline" src={require("../../assets/img/connectria-logo.svg")}></img> */}
                    {/* <img width="58px" className="mt-1 mb-1 d-lg-none" src={require("../../assets/img/connectria-logo-c.png")}></img> */}
                  </Link>
                  <div className="h-100 d-flex d-md-none align-items-center">
                    <h4 className="app-nav-title flex-fill m-0">{stateApp.pageNavTitle}</h4>
                  </div>
                </div>
                <div className="col-4">
                  <div className="d-flex mr-2 h-100 align-items-center justify-content-end">
                    <Link to="/app/support" className="mail-icon d-none d-md-inline pr-4">
                      <i className="fa fa-headset" id="support-ticketing-icon"></i>
                      <UncontrolledTooltip placement="bottom" target="support-ticketing-icon">
                        Support & Ticketing
                      </UncontrolledTooltip>
                      <TicketTabIndicator inboxCount={stateApp.inboxCount} style={{top:"11px", left:"27px"}}/>
                    </Link>
                    <Link to="/app/contact" className="mail-icon d-none d-md-inline pr-4">
                      <i className="far fa-address-book" id="contact-us-icon" style={{fontSize: "25px"}}></i>
                      <UncontrolledTooltip placement="bottom" target="contact-us-icon">
                        Contact Us
                      </UncontrolledTooltip>
                    </Link>
                    <div className="burger-thumbnail d-flex align-items-center justify-content-center text-uppercase" role="button" onClick={toggleSidebar}>
                      {stateApp.userInfo?.name.substr(0, 2)}
                    </div>
                    {/* <div className={burgerCssClass} onClick={toggleSidebar}>
                      <div className="burger-bar1"></div>
                      <div className="burger-bar2"></div>
                      <div className="burger-bar3"></div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <ContentPanel 
              title={stateApp.contentPanel.title} 
              visible={stateApp.contentPanel.visible} 
              className={stateApp.contentPanel.className}
              setPanelState={stateAppActions.setContentPanel}>
                {stateApp.contentPanel.content}
            </ContentPanel>
            <Switch>
                  {rawRoutes().filter(e => ((e.envs || []).includes(Enum.Env.ALL) || (e.envs || []).includes(stateApp.env))).map(({component: Cmp, ...route}, i) => {
                     
                      return (
                          <Route
                            key={i}
                            {...route}
                            path={route.layout + route.path}
                            component={route.component}
                            render={props => <Clickstream meta={route.clickstreamMeta}><Cmp {...route.props || {}} {...props} /></Clickstream>} 
                          />
                      );
                  })}
                   
                  <Route component={NotFound} />
            </Switch>
            {// we don't want the Footer to be rendered on map page
            props.location.pathname.indexOf("maps") !== -1 ? null : (
              <Footer fluid />
            )}
          </div>
          <Blade 
            title={stateApp.blade.title} 
            visible={stateApp.blade.visible} 
            setBladeState={stateAppActions.setBlade}>
              {stateApp.blade.content}
          </Blade>
        </div>
      </div>
      <SessionTimeoutModal/>
      {/* <FixedPlugin
        bgColor={this.state.backgroundColor}
        handleBgClick={this.handleBgClick}
      /> */}
    </>
  );
}

export default App;
